import Header from './Header';
import Footer from '../pages/Footer';
import { useAuth } from '../context/AuthContext';
import ScrollToTop from './ScrollToTop';
import { useLocation } from "react-router-dom";

const Layout = ({ children, openAuthModal }) => {
  const { logout } = useAuth();
  const location = useLocation();

  const hideFooterRoutes = [
    "/FeedBackSales",
    "/Report",
    "/TenderList",
    "/TaskList",
    "/sales-dashboard",
    "/Feedback",
    "/OperationsReport",
    "/FinanceReport",
    "/emp-customer-assignment",
    "/feedback"
  ];

  const shouldHideFooter = hideFooterRoutes.some(route =>
    location.pathname.startsWith(route)
  );

  return (
    <div className="d-flex flex-column min-vh-100">
      <Header openAuthModal={openAuthModal || (() => { })} />

      <div className="d-flex flex-grow-1 overflow-hidden">
        <main
          className="flex-grow-1 p-4 ove"
          style={{ background: '#ffffff', minWidth: 0, overflowX: 'hidden' }}
        >
          {children}
          <ScrollToTop />
        </main>
      </div>

      {!shouldHideFooter && <Footer />}
    </div>
  );
};

export default Layout; 